import React from 'react';
import FooterTop from '../../../Components/Shared/FooterTop';
import BabyCare from '../BabyCare';
import Beauty from '../Beauty';
import CovidSection from '../CovidSection/CovidSection';
import CustomersSays from '../CustomersSays/CustomersSays';
import Help from '../Help';
import HeroSearch from '../Hero/HeroSearch';
import HeroSlider from '../Hero/HeroSlider';
import OrderSteps from '../Hero/OrderSteps';
import RunningOffer from '../Hero/RunningOffer';
import Popular from '../Popular';
import PopularBrands from '../PopularBrands/PopularBrands';
import ProductCategories from '../ProductCategories/ProductCategories';
import PromoOffers from '../PromoOffers';
import SpecialCollections from '../SpecialCollections';
import { useSelector } from 'react-redux';
import Search from '../../searchPage/Search';
const Home = () => {
    const searchText = useSelector((state) => state.cart.search)
    console.log(searchText);
    return (
        <>{
            searchText ?

                <Search />
                :
                <>
                    <HeroSlider />
                    <HeroSearch />
                    <OrderSteps />
                    <RunningOffer />
                    <ProductCategories />
                    <CovidSection />
                    <PromoOffers />
                    <SpecialCollections />
                    <BabyCare />
                    <Beauty />
                    <Popular />
                    <CustomersSays />
                    <PopularBrands />
                    <Help />
                    <FooterTop />
                </>
        }

        </>
    );
};

export default Home;